import { FC } from 'react'
import { SequenceMenu } from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'

type Props = {
  creditNoteId: string
  label: string
  onClose: () => void
}

export const ViewCreditNoteMenuItem: FC<Props> = ({
  creditNoteId,
  label,
  onClose
}) => {
  const navigate = useNavigate()

  return (
    <SequenceMenu.Item
      uuid="view-credit-note"
      data-testid={`creditNotes.${creditNoteId}.menuItem.view`}
      label={label}
      onClick={e => {
        e.stopPropagation()
        onClose()
        navigate(`/credit-notes/${creditNoteId}`)
      }}
    />
  )
}
